// Default menu settings configurations

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  rolename: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        page: '/dashboard/newdashboard',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Sales Dashboard',
              page: '/dashboard/newdashboard',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Dashboard',
              page: '/dashboard/sales-dashboard',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Customers',
        icon: 'la-user',
        page: '/customer/customers',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Quotation',
              page: '/quotation/addquotation',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Quotations',
              page: '/quotation/allquotation',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'New Enquiry',
              page: '/customer/new-enquiry',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Enquiries',
              page: '/customer/enquiries',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Invoice',
        icon: 'icon-book-open',
        page: '/bill/addbill',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Sale Invoice',
              page: '/bill/addbill',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Invoices',
              page: '/bill/allbill',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Add Rent & Repair Invoice',
              page: '/rentinvoice/add',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Rent & Repair Invoices',
              page: '/rentinvoice/all',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            }
          ]
        }
      },
      {
        title: 'Inventory',
        icon: 'icon-drawer',
        page: '/inventory/addinventory',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Inventory',
              page: '/inventory/addinventory',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Inventories',
              page: '/inventory/allinventory',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Stock',
              page: '/stock/viewstock',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Add Used Item',
              page: '/stock/add-used-item',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Used Items',
              page: '/stock/all-used-items',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Products',
              page: '/admin/productandmanufacturer',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Vendors',
              page: '/admin/vendor',
              rolename: 'Admin,SuperAdmin',
            },
          ]
        }
      },
      {
        title: 'Account',
        icon: 'icon-calculator',
        page: '/account/add-purchase-request',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'New Payment Request',
              page: '/account/add-purchase-request',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Payment Requests',
              page: '/account/all-purchase-requests',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Salaries',
              page: '/account/process-employee-salaries',
              rolename: 'SuperAdmin'
            },
            {
              title: 'Add Expense',
              page: '/admin/addExpense',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Expenses',
              page: '/admin/allExpenses',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Challan',
        icon: 'icon-layers',
        page: '/challan/addchallan',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Challan',
              page: '/challan/addchallan',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Challans',
              page: '/challan/allchallan',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Admin',
        icon: 'la-certificate',
        page: '/admin/productandmanufacturer',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'All Stock',
              page: '/admin/allStock',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'System Configuration',
              page: '/masterdata/allmasterdatas',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Clients',
              page: '/admin/clients',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Reports',
        icon: 'icon-book-open',
        page: '/report/bill',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Invoice Report',
              page: '/report/billsReport',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Sales Report',
              page: '/report/salesReport',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Payments Report',
              page: '/report/payment-report',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Barcode Report',
              page: '/report/product-barcode-report',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Employees',
        icon: 'la-user',
        page: '/employee/employees',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'Add Leave',
              page: '/admin/addLeave',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Leaves',
              page: '/admin/allLeaves',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Upload Attendace file',
              page: '/admin/upload-attendance',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'View Employee Attendance',
              page: '/admin/view-employee-attendance',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Documents',
        icon: 'la-cloud',
        page: '/documents/upload-document',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Upload Document',
              page: '/documents/upload-document',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Documents',
              page: '/documents/all-documents',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
    ]
  },
  vertical_menu: {
    items: [
      {
        title: 'Home',
        icon: 'la-home',
        page: '/dashboard/newdashboard',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Sales Dashboard',
              page: '/dashboard/newdashboard',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Dashboard',
              page: '/dashboard/sales-dashboard',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Customers',
        icon: 'la-user',
        page: '/customer/customers',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Quotation',
              page: '/quotation/addquotation',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Quotations',
              page: '/quotation/allquotation',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'New Enquiry',
              page: '/customer/new-enquiry',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Enquiries',
              page: '/customer/enquiries',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Invoice',
        icon: 'icon-book-open',
        page: '/bill/addbill',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Sale Invoice',
              page: '/bill/addbill',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Invoices',
              page: '/bill/allbill',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Add Rent & Repair Invoice',
              page: '/rentinvoice/add',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Rent & Repair Invoices',
              page: '/rentinvoice/all',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            }
          ]
        }
      },
      {
        title: 'Inventory',
        icon: 'icon-drawer',
        page: '/inventory/addinventory',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Inventory',
              page: '/inventory/addinventory',
              rolename: 'Admin,SuperAdmin,Developer,Hardware',
            },
            {
              title: 'Inventories',
              page: '/inventory/allinventory',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Stock',
              page: '/stock/viewstock',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Add Used Item',
              page: '/stock/add-used-item',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Used Items',
              page: '/stock/all-used-items',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Products',
              page: '/admin/productandmanufacturer',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Vendors',
              page: '/admin/vendor',
              rolename: 'Admin,SuperAdmin',
            },
          ]
        }
      },
      {
        title: 'Account',
        icon: 'icon-calculator',
        page: '/account/add-purchase-request',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'New Payment Request',
              page: '/account/add-purchase-request',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'Payment Requests',
              page: '/account/all-purchase-requests',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Salaries',
              page: '/account/process-employee-salaries',
              rolename: 'SuperAdmin'
            },
            {
              title: 'Add Expense',
              page: '/admin/addExpense',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Expenses',
              page: '/admin/allExpenses',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Challan',
        icon: 'icon-layers',
        page: '/challan/addchallan',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Add Challan',
              page: '/challan/addchallan',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Challans',
              page: '/challan/allchallan',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Admin',
        icon: 'la-certificate',
        page: '/admin/productandmanufacturer',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'All Stock',
              page: '/admin/allStock',
              rolename: 'Admin,SuperAdmin',
            },
            {
              title: 'System Configuration',
              page: '/masterdata/allmasterdatas',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Clients',
              page: '/admin/clients',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Reports',
        icon: 'icon-book-open',
        page: '/report/bill',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Invoice Report',
              page: '/report/billsReport',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Sales Report',
              page: '/report/salesReport',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Payments Report',
              page: '/report/payment-report',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Barcode Report',
              page: '/report/product-barcode-report',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
      {
        title: 'Employees',
        icon: 'la-user',
        page: '/employee/employees',
        rolename: 'Admin,SuperAdmin',
        submenu: {
          items: [
            {
              title: 'Add Leave',
              page: '/admin/addLeave',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Leaves',
              page: '/admin/allLeaves',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'Upload Attendace file',
              page: '/admin/upload-attendance',
              rolename: 'Admin,SuperAdmin'
            },
            {
              title: 'View Employee Attendance',
              page: '/admin/view-employee-attendance',
              rolename: 'Admin,SuperAdmin'
            }
          ]
        }
      },
      {
        title: 'Documents',
        icon: 'la-cloud',
        page: '/documents/upload-document',
        rolename: 'Admin,SuperAdmin,Developer,Hardware',
        submenu: {
          items: [
            {
              title: 'Upload Document',
              page: '/documents/upload-document',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            },
            {
              title: 'Documents',
              page: '/documents/all-documents',
              rolename: 'Admin,SuperAdmin,Developer,Hardware'
            }
          ]
        }
      },
    ]
  }

};





